// ReportType.ts
// Enum for report types: normal vs jury-based

export enum ReportType {
    NORMAL = 0,
    JURY_BASED = 1
}
